import {ChangeDetectionStrategy, Component, inject, signal, Signal, viewChild, WritableSignal} from "@angular/core";
import {Page} from "../../navigation/page";
import {ButtonComponent} from "../../buttons/button/button.component";
import {ButtonProminence} from "../../buttons/button/button";
import {FormComponent} from '../../inputs/form/form.component';
import {OptionComponent} from '../../inputs/selection-field/option.component';
import {SelectionFieldComponent} from '../../inputs/selection-field/selection-field.component';
import {TextAreaFieldComponent} from '../../inputs/text-area-field/text-area-field.component';
import {ContentMessageComponent} from "../../notification/message/content-message.component";
import {MessageLevel} from "../../notification/message/message";
import AppFeedbackService from "../app-feedback.service";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {FormsModule} from '@angular/forms';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';

@Component({
    selector: "woa-feedback-page",
    templateUrl: "./feedback-page.component.html",
    providers: [
        AppFeedbackService,
        {provide: Page, useExisting: FeedbackPageComponent}
    ],
    imports: [
        ButtonComponent,
        ContentMessageComponent,
        FormComponent,
        FormsModule,
        ModalPageLayoutComponent,
        OptionComponent,
        PageFooterControlDirective,
        SelectionFieldComponent,
        TextAreaFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackPageComponent extends Page {
    private appFeedbackService: AppFeedbackService = inject(AppFeedbackService);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    ButtonProminence = ButtonProminence;
    MessageLevel = MessageLevel;

    public readonly form: Signal<FormComponent | undefined> = viewChild(FormComponent);

    public readonly sent: WritableSignal<boolean> = signal<boolean>(false);

    category: string;
    message: string;

    send(): void {
        if (!this.form()?.valid) {
            return;
        }

        void this.appFeedbackService.performAction({
            category: this.category,
            message: this.message
        });
        this.sent.set(true);
    }
}
